export default __webpack_public_path__ + "static/media/avatar.2a284a84.jpg";